import type { FaireProductEntity } from "../../entity_types/product";

export const p_ywysjmr32w: FaireProductEntity = {
  token: "p_ywysjmr32w",
  type: "product",
  name: "Smoked Bamboo Woven Basket Tray(Campfire Odor)",
  brandToken: "b_3xzs38fcyp",
  brandName: "Fodory",
  imageUrl:
    "https://cdn.faire.com/fastly/15064ceb44bd373a969450770b20c630b9cd9d95ab1b98239a7554eff20d914c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3657579c9f1d2c07c54928924acc1108bfa117b631b9992be3e78d6485127fc1.jpeg",
    "https://cdn.faire.com/fastly/c4df45f6119042e44d256c74ab42f2324b25f3c2cf7256111f201551a94b4a79.jpeg",
    "https://cdn.faire.com/fastly/37972396cccd603fce0de534cd879472490e23e4212b50dce3a74af949a22662.jpeg",
    "https://cdn.faire.com/fastly/57f58f795b3883ae601961c9a1b0a2cdf6ca68d19d3cda87706c9bda3bd943f8.jpeg",
    "https://cdn.faire.com/fastly/644202671ca2cd498e8bc90461d20ae5e47f069f5b8642fd911b8cc13b3f0f2d.jpeg",
    "https://cdn.faire.com/fastly/d72c65d46326e64f0edea5eefa34be9e3fe725a35469f97ae9e0e267e17e7c29.jpeg",
    "https://cdn.faire.com/fastly/714dd1a8501717e5d818e16917ef18b4a86092d3a699bb242cff8d0b39fe50aa.jpeg",
  ],
  priceDollars: 5.99,
  description:
    "Bring natural elegance and functionality to your home with this stunning Smoked Bamboo Woven Basket Tray. Handcrafted from high-quality bamboo and treated with a unique smoked finish, this tray exudes a rustic yet refined charm.\n\nSmoked bamboo involves a natural treatment that gives the bamboo a rich, darkened color and a more durable finish. The smoking process helps to preserve the bamboo by reducing its susceptibility to pests, mold, and rot. The treatment gives the bamboo a longer lifespan, especially in humid or high-moisture environments. This item is naturally smoked during the finishing process and may have a light campfire-like scent. The smell will gradually fade over time and with normal use.\n\n * Material: Bamboo; ***SMOKED, CAMPFIRE ODOR***\n * Size S: 9.8 x 6.2 x 1.6''/25 X 16 X 4cm \n * Size M: 11 x 7.8 x 1.9''/ 29 x 20 x 5cm \n * Care: Wipe clean with a damp cloth; avoid soaking \n",
  tags: [],
  msrpDollars: 11.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:26.117Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
